<template>
  <div class="eyeVoucher">
    <table>
      <tr>
        <td rowspan="4">
          <div class="voucherType">
            <el-radio-group v-model="voucher.type" size="mini">
              <el-radio :label="1" border>远用</el-radio>
              <el-radio :label="2" border>近用</el-radio>
              <el-radio :label="3" border>隐形</el-radio>
            </el-radio-group>
          </div>
        </td>
        <td></td>
        <td>球镜</td>
        <td>柱镜</td>
        <td>轴向</td>
        <td>下加光(ADD)</td>
        <td>矫正视力</td>
      </tr>
      <tr>
        <td>右眼</td>
        <td>
          <el-input v-model="voucher.rSphLens" placeholder="例: -1.25"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.rCyl" placeholder="例: 0.5"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.rAxial" placeholder="例: 180"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.rAdd" placeholder="例: +1.00"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.rCva" placeholder="例: 1.2"></el-input>
        </td>
      </tr>
      <tr>
        <td>左眼</td>
        <td>
          <el-input v-model="voucher.lSphLens" placeholder="例: -1.25"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.lCyl" placeholder="例: 0.5"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.lAxial" placeholder="例: 180"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.lAdd" placeholder="例: +1.00"></el-input>
        </td>
        <td>
          <el-input v-model="voucher.lCva" placeholder="例: 1.2"></el-input>
        </td>
      </tr>
      <tr>
        <td>瞳距</td>
        <td><el-input v-model="voucher.pd" placeholder="例: 68"></el-input></td>
        <td colspan="4"></td>
      </tr>
      <tr>
        <td>备注</td>
        <td colspan="7">
          <el-input v-model="voucher.remark"></el-input>
        </td>
      </tr>
    </table>
    <el-divider v-if="operation == 'add'"></el-divider>
    <el-button v-if="operation == 'add'" class="btnVoucher" type="primary" plain size="mini" @click="addVoucher">添加</el-button>
  </div>
</template>

<script>
import { addVoucher,findVoucher } from "@/api/index";
export default {
  name: "eyeVoucher",
  props: {
    operation: String,
    voucherId: Number
  },
  data() {
    return {
      fullscreenLoading: false,
      voucher: {
        type: 1,
        lSphLens: "",
        lCyl: "",
        lAxial: "",
        lAdd: "",
        lCva: "",
        rSphLens: "",
        rCyl: "",
        rAxial: "",
        rAdd: "",
        rCva: "",
        pd: "",
        remark: ""
      }
    };
  },
  methods: {
    addVoucher(){
       let loading = this.$loading({
          lock: true,
          text: '提交验光单中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      addVoucher(this.voucher).then(res => {
            loading.close();
            if (res.success == true) {
              this.voucher.type = 1
              this.voucher.lSphLens = ""
              this.voucher.lCyl = ""
              this.voucher.lAxial = ""
              this.voucher.lAdd = ""
              this.voucher.lCva = ""
              this.voucher.rSphLens = ""
              this.voucher.rCyl = ""
              this.voucher.rAxial = ""
              this.voucher.rAdd = ""
              this.voucher.rCva = ""
              this.voucher.pd = ""
              this.voucher.remark = ""
              this.$emit("created", res.result);
            } else {
               this.$notify.error({
                  title: '错误',
                  message: res.message
                })
            }
          })
    }
  },
  created() {
    if(this.operation == 'show'){
      let that = this
      findVoucher({voucherId: this.voucherId}).then(res => {
            if (res.success == true) {
              that.voucher = res.result
            } else {
               that.$notify.error({
                  title: '错误',
                  message: res.message
                })
            }
          })
    }
  }
};
</script>
<style lang="scss">
.eyeVoucher {
  padding: 20px;

  .el-radio {
    margin-right: 0px;
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0px;
  }

  .voucherType {
    display: flex;
    flex-direction: column;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border: none;

    tr {
      height: 35px;
      td {
        width: 100px;
        border: solid #c0c4cc 1px;
        text-align: center;

        .el-input__inner {
          border-radius: 0px;
          border: 1px solid #ffffff;
        }
        ::v-deep .el-input__inner:focus {
          border: 1px solid #4d7cfe;
        }
      }
    }
  }

  .btnVoucher {
    position: absolute;
    right: 40px;
    bottom: 20px;
  }
}
</style>
